import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { SITE } from "@/lib/site";

export default function CTABand() {
  return (
    <section data-testid="cta-band" className="bg-amber-600 text-white">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-20 md:py-28">
        <div className="grid grid-cols-12 gap-8 items-end">
          <div className="col-span-12 md:col-span-8">
            <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-white/80">
              Engage with the Coalition
            </div>
            <h2 className="mt-4 font-display font-black text-3xl md:text-5xl leading-[1.05] tracking-tight max-w-3xl">
              Bring a stabilizing presence to the environment you're responsible for.
            </h2>
          </div>

          <div className="col-span-12 md:col-span-4 flex flex-col gap-3 md:items-end">
            <Link
              to="/contact"
              data-testid="cta-band-contact"
              className="group inline-flex items-center justify-between gap-4 w-full md:w-auto bg-slate-900 hover:bg-black text-white px-6 py-4 font-semibold text-sm transition-colors"
            >
              Start a conversation
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </Link>
            <a
              href={SITE.givebutterUrl}
              target="_blank"
              rel="noreferrer noopener"
              data-testid="cta-band-donate"
              className="group inline-flex items-center justify-between gap-4 w-full md:w-auto border border-white/40 hover:border-white px-6 py-4 font-semibold text-sm transition-colors"
            >
              Fund the doctrine
              <ArrowUpRight size={16} className="group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
